import { useState } from 'react';

import Buttons from '@klv/molecules/buttons';
import { generateClassName } from '@klv/shared/utils/functions';
import useIsHydrated from '@klv/hooks/useIsHydrated';

import CountdownTimer from './countdownTimer';
import * as styles from './styles/countdownHero.module.css';
import type { ICountdownHero } from './types';


const CountdownHero = ({
  buttons,
  className = '',
  countdown,
  customPadding: { customPaddingBottom, customPaddingTop },
  eyebrow,
  headline,
  subtext,
  upperHeadline,
  upperSubtext,
  ...props
}: ICountdownHero) => {

  const [displayed, setDisplayed] = useState<boolean>(true);
  // Stop the component from rendering on the server to avoid hydration errors.
  const isHydrated = useIsHydrated();
  if (!isHydrated || !displayed) return null;

  return (
    <div className={generateClassName([className, styles.countdownHero, `${customPaddingTop}PaddingTop`, `${customPaddingBottom}PaddingBottom` ])} {...props}>
      <div className={generateClassName(['grid', styles.countdownGrid])}>
        <div className={styles.header}>
          {upperHeadline?.length && <div className={generateClassName([styles.upperHeadline])}>{upperHeadline}</div>}
          {upperSubtext?.length && <div className={generateClassName([styles.upperSubtext])}>{upperSubtext}</div>}
        </div>
        <div className={styles.countdownCard}>
          <div className={styles.cardContent}>
            {eyebrow?.length && <div className={styles.eyebrow}>{eyebrow}</div>}
            <div className={generateClassName([styles.headline])}>{headline}</div>
            {subtext?.length && <div className="p2">{subtext}</div>}

            <Buttons className={styles.buttons} buttons={buttons} buttonColor='light' variants={['tertiary']}/>
          </div>
          <div className={styles.countdown} aria-hidden>
            <CountdownTimer countdown={countdown} setDisplayed={setDisplayed}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownHero;
